import type { ReactNode } from "react";
import { User } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import {
  remitoOperatorNames,
  type RemitoOperatorSource,
} from "./operatorSnapshot";

/** Mismo chip que UsuarioGeneradorBadge en detalle de cierre diario (F3). */
function OperatorNameBadge({ children }: { children: ReactNode }) {
  return (
    <Badge variant="secondary" className="rounded-full font-normal">
      <User className="h-3 w-3" aria-hidden="true" />
      {children}
    </Badge>
  );
}

export function RemitoOperatorBadges({
  source,
  showGeneroLabel = true,
}: {
  source: RemitoOperatorSource;
  /** Remitos keep «Generó»; Presupuestos / Ventas / Recibos are name-only. */
  showGeneroLabel?: boolean;
}) {
  const { genero, ultimaEntrega } = remitoOperatorNames(source);
  if (!genero && !ultimaEntrega) return null;
  return (
    <>
      {genero ? (
        <OperatorNameBadge>
          {showGeneroLabel ? `Generó ${genero}` : genero}
        </OperatorNameBadge>
      ) : null}
      {ultimaEntrega ? (
        <OperatorNameBadge>Última entrega {ultimaEntrega}</OperatorNameBadge>
      ) : null}
    </>
  );
}
